import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { UsuarioEmpresaInserirComponent } from "./usuario-empresa-inserir.component";

import { ButtonModule } from "primeng/button";;
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { HttpClientModule } from "@angular/common/http";
import { DividerModule } from "primeng/divider";
import { ConfirmationService } from "primeng/api";
import { FormsModule } from "@angular/forms";
import { MessagesModule } from "primeng/messages";
import { DropdownModule } from "primeng/dropdown";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputMaskModule } from "primeng/inputmask";
import { PasswordModule } from 'primeng/password';
import { TreeModule } from "primeng/tree";
import { DialogModule } from "primeng/dialog";
import { TooltipModule } from "primeng/tooltip";
import {TreeTableModule} from 'primeng/treetable';
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TreeModule,
        DialogModule,
        ConfirmDialogModule,
        ButtonModule,
        InputTextModule,
        TableModule,
        HttpClientModule,   
        DividerModule,
        MessagesModule,
        DropdownModule,
        InputSwitchModule,
        InputMaskModule,
        PasswordModule,
        TooltipModule,
        TreeTableModule,
        ProgressSpinnerModule
    ],
    providers: [ConfirmationService],
    declarations: [UsuarioEmpresaInserirComponent],
    exports: [UsuarioEmpresaInserirComponent]
})
export class UsuarioEmpresaInserirModule { }
